import gql from 'graphql-tag';

export const GET_COMPLAINER_BY_ID = gql(`
  query GetComplainer($id: Int!) {
    complainer(id: $id) {
      id
      title
      firstName
      email
      middleName
      lastName
      comments
      preferredResponseMethod
      phoneNumbers {
        number
      }
      address {
        country
        city
        postcode
        state
        streetAddress
        streetAddress2
        position {
          altitude
          latitude
          longitude
        }
      }
    }
  }
`);
